import { forwardRef, type Ref, type SVGProps } from "react";

function ScallopedDiamondWithStarColored(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} viewBox="0 0 114 114" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M54.6054 20.4615C60.0051 15.0619 68.7594 15.062 74.1591 20.4615L75.329 21.6314C78.5839 24.8861 82.9985 26.7144 87.6015 26.7144H87.8994C95.5358 26.7144 101.727 32.9052 101.727 40.5416V40.8394C101.727 45.4426 103.556 49.857 106.81 53.1119L107.979 54.2818C113.379 59.6816 113.379 68.4358 107.979 73.8355L106.81 75.0055C103.556 78.2604 101.727 82.6748 101.727 87.2779V87.5758C101.727 95.2122 95.5358 101.403 87.8994 101.403H87.6015C82.9984 101.403 78.584 103.232 75.329 106.487L74.1591 107.656C68.7594 113.056 60.0051 113.056 54.6054 107.656L53.4355 106.487C50.1806 103.232 45.7662 101.403 41.163 101.403H40.8652C33.2288 101.403 27.038 95.2122 27.038 87.5758V87.2779C27.038 82.675 25.2097 78.2603 21.955 75.0055L20.7851 73.8355C15.3856 68.4358 15.3855 59.6815 20.7851 54.2818L21.954 53.1119H21.955C25.2097 49.857 27.038 45.4424 27.038 40.8394V40.5416C27.038 32.9052 33.2288 26.7144 40.8652 26.7144H41.163C45.766 26.7144 50.1806 24.8861 53.4355 21.6314L54.6054 20.4615Z"
        fill="url(#scalloped_diamond_with_star_svg__a)"
        stroke="#9ED79D"
        strokeWidth="3.52941"
      />
      <path
        d="M41.7481 54.5615L63.174 42.7765C63.5441 42.5729 63.9597 42.4661 64.3821 42.4661C64.8045 42.4661 65.2201 42.5729 65.5902 42.7765L87.0161 54.5615C87.3232 54.7304 87.5915 54.9617 87.8037 55.2407C88.0158 55.5197 88.1671 55.84 88.2478 56.1811C88.3284 56.5221 88.3367 56.8763 88.2719 57.2208C88.2072 57.5652 88.071 57.8922 87.872 58.1808L66.4449 89.2475C66.2144 89.5815 65.9062 89.8545 65.5469 90.0431C65.1876 90.2317 64.7879 90.3302 64.3821 90.3302C63.9763 90.3302 63.5766 90.2317 63.2173 90.0431C62.858 89.8545 62.5498 89.5815 62.3193 89.2475L40.8922 58.182C40.6932 57.8935 40.557 57.5665 40.4923 57.222C40.4275 56.8776 40.4358 56.5234 40.5164 56.1823C40.5971 55.8413 40.7484 55.5209 40.9605 55.242C41.1727 54.963 41.441 54.7316 41.7481 54.5628V54.5615Z"
        fill="url(#scalloped_diamond_with_star_svg__b)"
      />
      <path
        d="M16.0291 1.58824C16.0291 1.00347 15.555 0.529419 14.9702 0.529419C14.3855 0.529419 13.9114 1.00347 13.9114 1.58824C13.9114 5.99331 12.9392 8.92337 11.0929 10.7697C9.24655 12.616 6.31649 13.5882 1.91142 13.5882C1.32665 13.5882 0.8526 14.0623 0.8526 14.6471C0.8526 15.2318 1.32665 15.7059 1.91142 15.7059C6.31649 15.7059 9.24655 16.6781 11.0929 18.5244C12.9392 20.3708 13.9114 23.3008 13.9114 27.7059C13.9114 28.2907 14.3855 28.7647 14.9702 28.7647C15.555 28.7647 16.0291 28.2907 16.0291 27.7059C16.0291 23.3008 17.0013 20.3708 18.8476 18.5244C20.6939 16.6781 23.624 15.7059 28.0291 15.7059C28.6138 15.7059 29.0879 15.2318 29.0879 14.6471C29.0879 14.0623 28.6138 13.5882 28.0291 13.5882C23.624 13.5882 20.6939 12.616 18.8476 10.7697C17.0013 8.92337 16.0291 5.99331 16.0291 1.58824Z"
        fill="#0D2B57"
      />
      <defs>
        <linearGradient
          id="scalloped_diamond_with_star_svg__a"
          x1="42.1471"
          y1="14.6471"
          x2="64.3824"
          y2="113.471"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1F2E8" />
          <stop offset="1" stopColor="#B9EBBA" />
        </linearGradient>
        <linearGradient
          id="scalloped_diamond_with_star_svg__b"
          x1="48.4268"
          y1="48.4491"
          x2="64.381"
          y2="90.3306"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#094534" />
          <stop offset="1" stopColor="#4D9863" />
        </linearGradient>
      </defs>
    </svg>
  );
}

const ForwardRef = forwardRef(ScallopedDiamondWithStarColored);
export default ForwardRef;
